import axios from 'axios'
import { getAccessToken } from './auth'

const baseURL = process.env.BACKEND_API_ORIGIN

const api = axios.create({
  baseURL: `${baseURL}`,
  headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getAccessToken()}` },
  timeout: 30000
})

api.interceptors.request.use(async (config) => {
  return config
})

api.interceptors.response.use(response => {
  return response
}, async (err) => {
  if (err.response) {
    // message.error(`${err.response.status}: ${err.response.data.message}`, 10);
    console.error('err', err.response)
  } else if (err.isAxiosError) {
    console.error('Axios err', err)
  } else {
    console.error('unknown err', err)
  }
  return Promise.reject(err)
})

export default api




//////////////////
// WEBPACK FOOTER
// ./utils/latestApi.js
// module id = sxc0
// module chunks = 1